export interface DataItem {
    key: string;
    datum: string;
    uzivatel: string;
    zeme: string;
    flagCode: string;
    kategorie: string;
    nabidka: string;
    typ: string;
    id: string;
    odmena: string;
    castka: string;
}

export const data: DataItem[] = [
    {
        key: "1",
        datum: "05.01.2022 12:00",
        uzivatel: "Anna Schmidt",
        zeme: "Německo",
        flagCode: "de",
        kategorie: "Finance",
        nabidka: "Commerzbank",
        typ: "Lead",
        id: "220",
        odmena: "210",
        castka: "5,789.32",
    },
    {
        key: "2",
        datum: "07.01.2022 15:30",
        uzivatel: "David Martin",
        zeme: "Spojené království",
        flagCode: "gb",
        kategorie: "Finance",
        nabidka: "HSBC",
        typ: "Click",
        id: "221",
        odmena: "160",
        castka: "11,234.56",
    },
    {
        key: "3",
        datum: "09.01.2022 08:20",
        uzivatel: "Elena Ivanova",
        zeme: "Rusko",
        flagCode: "ru",
        kategorie: "Finance",
        nabidka: "Sberbank",
        typ: "iFrame",
        id: "222",
        odmena: "230",
        castka: "14,987.65",
    },
    {
        key: "4",
        datum: "12.01.2022 14:10",
        uzivatel: "Carlos Garcia",
        zeme: "Španělsko",
        flagCode: "es",
        kategorie: "Finance",
        nabidka: "CaixaBank",
        typ: "Lead",
        id: "223",
        odmena: "190",
        castka: "3,210.98",
    },
    {
        key: "5",
        datum: "15.01.2022 17:45",
        uzivatel: "Olga Nowak",
        zeme: "Polsko",
        flagCode: "pl",
        kategorie: "Finance",
        nabidka: "mBank",
        typ: "Click",
        id: "224",
        odmena: "180",
        castka: "6,543.21",
    },
];
